import { css } from '@emotion/react'
import { Cell, Grid, Heading, HFlow, Icon, Text, VFlow } from 'bold-ui'
import { InfoIcon } from 'components/InfoIcon'
import { Color } from 'csstype'
import { formatDate } from 'util/date/formatDate'

import {
  EXAMES_HEPATITE_B_TOOLTIP_TEXT,
  EXAMES_HEPATITE_C_TOOLTIP_TEXT,
  EXAMES_HIV_TOOLTIP_TEXT,
  EXAMES_SIFILIS_SAUDE_MULHER_TOOLTIP_TEXT,
} from '../constants-acompanhamentoCondicaoSaudeAccordion'

interface RastreamentoAcompanhamentoIstPanelProps {
  hiv: LocalDate
  sifilis: LocalDate
  hepatiteB: LocalDate
  hepatiteC: LocalDate
  iconColor: Color
}

export function RastreamentoAcompanhamentoIstPanel(props: Readonly<RastreamentoAcompanhamentoIstPanelProps>) {
  const { hiv, sifilis, hepatiteB, hepatiteC, iconColor } = props

  return (
    <Grid gap={1} gapVertical={0.5} alignItems='baseline'>
      <Cell size={12}>
        <HFlow hSpacing={0.25} alignItems='center'>
          <Icon icon='fileWithItemsFilled' size={1} color={iconColor} />
          <Heading level={4}>Rastreamento e acompanhamento para IST (última avaliação)</Heading>
        </HFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.125}>
          <HFlow hSpacing={0.25}>
            <Text fontWeight='bold'>HIV</Text>
            <InfoIcon icon='infoCircleFilled' text={EXAMES_HIV_TOOLTIP_TEXT} tooltipStyle={styles.tooltipStyle} />
          </HFlow>
          <Text>{formatDate(hiv)}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.125}>
          <HFlow hSpacing={0.25}>
            <Text fontWeight='bold'>Sífilis</Text>
            <InfoIcon
              icon='infoCircleFilled'
              text={EXAMES_SIFILIS_SAUDE_MULHER_TOOLTIP_TEXT}
              tooltipStyle={styles.tooltipStyle}
            />
          </HFlow>
          <Text>{formatDate(sifilis)}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.125}>
          <HFlow hSpacing={0.25}>
            <Text fontWeight='bold'>Hepatite B</Text>
            <InfoIcon
              icon='infoCircleFilled'
              text={EXAMES_HEPATITE_B_TOOLTIP_TEXT}
              tooltipStyle={styles.tooltipStyle}
            />
          </HFlow>
          <Text>{formatDate(hepatiteB)}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.125}>
          <HFlow hSpacing={0.25}>
            <Text fontWeight='bold'>Hepatite C</Text>
            <InfoIcon
              icon='infoCircleFilled'
              text={EXAMES_HEPATITE_C_TOOLTIP_TEXT}
              tooltipStyle={styles.tooltipStyle}
            />
          </HFlow>
          <Text>{formatDate(hepatiteC)}</Text>
        </VFlow>
      </Cell>
    </Grid>
  )
}

const styles = {
  tooltipStyle: css`
    max-width: 31rem;
    white-space: pre-line;
  `,
}
